import Vue from "vue";
import VueI18n from "vue-i18n";

import zh from "./lang/zh.json";
import en from "./lang/en.json";

Vue.use(VueI18n);

// 获取浏览器语言
function getBrowserLocale() {
    const navigatorLocale =
        navigator.languages !== undefined
            ? navigator.languages[0]
            : navigator.language;

    if (!navigatorLocale) {
        return "en";
    }

    // 获取语言代码 (如 'zh-CN' -> 'zh', 'en-US' -> 'en')
    const locale = navigatorLocale.trim().split(/[-_]/)[0];

    // 只支持中文和英文，其他语言默认使用英文
    return locale === "zh" ? "zh" : "en";
}

// 优先级: localStorage > 浏览器语言 > 默认英文
const saved = localStorage.getItem("locale") || getBrowserLocale();


export default new VueI18n({
    locale: saved,
    fallbackLocale: "en",
    messages: { zh, en },
});
